import { IBookingManagementActionTypes, IBookingManagementActionCreator } from "models/IBookingManagementState";

const initialState: any = {
  data: [],
};

const reducer = (state = initialState, { type, payload }: IBookingManagementActionCreator) => {
  switch (type) {
    case IBookingManagementActionTypes.FETCH_TRIP_ANALYTICS_REQUEST:
      return {
        ...state,
        data: [],
      };
    case IBookingManagementActionTypes.FETCH_TRIP_ANALYTICS_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
